__webpack_require__.p = "/api/v1/resources/statics/viewMessageFrontend/";